module.exports = {
  "/": {
    "name": "notifications-in-app",
    "success": {
      "notifications-in-app page loaded": [
        "NOTIFICATIONS_IN_APP_LOAD"
      ]
    },
    "error": [
      "NOTIFICATIONS_IN_APP_ERROR"
    ]
  },
  "/banners": {
    "name": "banners",
    "success": {
      "banners loaded": [
        "BANNERS_LOAD"
      ]
    },
    "error": [
      "BANNERS_ERROR"
    ]
  },
  "/floating": {
    "name": "floating notifications",
    "success": {
      "floating notifications loaded": [
        "FLOATING_NOTIFICATIONS_LOAD"
      ]
    },
    "error": [
      "FLOATING_NOTIFICATIONS_ERROR"
    ]
  },
  "/tease": {
    "name": "tease notifications",
    "success": {
      "tease notifications loaded": [
        "TEASE_NOTIFICATIONS_LOAD"
      ]
    },
    "error": [
      "TEASE_NOTIFICATIONS_ERROR"
    ]
  },
  "/sidebar": {
    "name": "sidebar notifications",
    "success": {
      "sidebar notifications loaded": [
        "SIDEBAR_NOTIFICATIONS_LOAD"
      ]
    },
    "error": [
      "SIDEBAR_NOTIFICATIONS_ERROR"
    ]
  }
};